import colors from "./colors";

const { grey, white, background } = colors;

const globals = {
  html: {
    scrollBehavior: "smooth",
    WebkitFontSmoothing: "antialiased",
    MozOsxFontSmoothing: "grayscale",
    backgroundColor: background.default,
  },

  "*, *::before, *::after": {
    margin: 0,
    padding: 0,
    boxSizing: "border-box",
  },

  "a, a:link, a:visited": {
    textDecoration: "none",
    transition: "color 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
  },

  "a.link, .link, a.link:link, .link:link, a.link:visited, .link:visited": {
    color: grey[300],
    transition: "color 0.2s cubic-bezier(0.4, 0, 0.2, 1)",

    "&:hover, &:focus": {
      color: grey[100],
    },
  },

  // Custom scrollbar styles for dark mode
  "::-webkit-scrollbar": {
    width: "8px",
    height: "8px",
    backgroundColor: background.default,
  },

  "::-webkit-scrollbar-track": {
    backgroundColor: background.default,
    borderRadius: "4px",
  },

  "::-webkit-scrollbar-thumb": {
    backgroundColor: grey[600],
    borderRadius: "4px",
    border: `1px solid ${grey[700]}`,

    "&:hover": {
      backgroundColor: grey[500],
    },
  },

  "::-webkit-scrollbar-corner": {
    backgroundColor: background.default,
  },

  // Firefox scrollbar
  "*": {
    scrollbarWidth: "thin",
    scrollbarColor: `${grey[600]} ${background.default}`,
  },

  // Selection styles
  "::selection": {
    backgroundColor: colors.primary.main,
    color: white.main,
  },

  "::-moz-selection": {
    backgroundColor: colors.primary.main,
    color: white.main,
  },

  // Focus outline improvements
  ":focus-visible": {
    outline: `2px solid ${colors.primary.main}`,
    outlineOffset: "2px",
  },

  // Smooth transitions for interactive elements
  "button, input, textarea, select": {
    transition: "color 0.2s cubic-bezier(0.4, 0, 0.2, 1), background-color 0.2s cubic-bezier(0.4, 0, 0.2, 1), border-color 0.2s cubic-bezier(0.4, 0, 0.2, 1), box-shadow 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
  },

  // Strip UA "buttonface" fill from unstyled <button> (shows as a light box in dark mode).
  // Keep MUI ButtonBase (picker days, icon buttons, tabs) out of this reset.
  "button:not(.MuiButtonBase-root)": {
    appearance: "none",
    WebkitAppearance: "none",
    backgroundColor: "transparent",
    color: "inherit",
    font: "inherit",
    border: "none",
    padding: 0,
  },

  // Card hover effects
  ".MuiCard-root": {
    transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
  },

  // Typography enhancements
  "body": {
    fontFamily: `"Google Sans Flex", "Roboto", "Helvetica", "Arial", sans-serif`,
    fontSize: "15px",
    lineHeight: "1.6",
    color: colors.text.main,
    backgroundColor: background.default,
  },

  // Better focus styles for accessibility
  ".MuiButton-root:focus, .MuiIconButton-root:focus": {
    outline: "none",
    boxShadow: `0 0 0 3px ${colors.primary.main}40`,
  },

  // Loading spinner improvements for dark mode
  ".spinner-overlay": {
    backdropFilter: "blur(4px)",
    backgroundColor: "rgba(0, 0, 0, 0.8)",
  },

  ".spinner": {
    borderColor: `${grey[700]} ${grey[700]} ${colors.primary.main} ${grey[700]}`,
  },

  ".gemini-surface": {
    backgroundColor: background.paper,
    border: `1px solid ${colors.divider}`,
    borderRadius: "16px",
  },

  ".gemini-surface-muted": {
    backgroundColor: background.sectionAlt,
    border: `1px solid ${colors.divider}`,
    borderRadius: "16px",
  },
};

export default globals;
